import React from 'react';
import './Handbook.css';

const Handbook = () => (
  <div className="handbook-container">
    <h2>AFFEERCE Handbook</h2>
    <p>Explore the foundational principles, processes, and practical guides of the AFFEERCE system.</p>
    <a
      href="https://affeercewebsite20180716091632.azurewebsites.net/ContentPage.aspx"
      target="_blank"
      rel="noreferrer"
      className="handbook-button"
    >
      📘 Read the AFFEERCE Handbook
    </a>
  </div>
);

export default Handbook;
